<template>
    <svg viewBox="0 0 510 296" v-bind="$attrs" xmlns="http://www.w3.org/2000/svg">
        <path d="M0 0 h 510 v 296 h -510 z" :fill="realBgFill"></path>
        <g id="smash-delta" :fill="realFill">
            <sd-smash></sd-smash>
            <sd-delta></sd-delta>
            <sd-shapes :shape="realShape" :fill="realFill" :width="128" :height="80"></sd-shapes>
        </g>
    </svg>
</template>

<script>
import SdSmash from './SdSmash'
import SdDelta from './SdDelta'
import SdShapes from './SdShapes.vue'
import getRealColour from './util/getRealColour'

export default {
    components: {
        SdSmash,
        SdDelta,
        SdShapes
    },

    props: {
        fill: {
            type: String,
            default: 'sd-black'
        },
        bgFill: {
            type: String,
            default: 'none'
        },
        shape: {
            type: String,
            default: 'bars'
        },
        animated: {
            type: Boolean,
            default: false
        },
        interval: {
            type: Number,
            default: 5000
        }
    },

    data() {
        return {
            i: 0,
            shapes: [
                'bars',
                'circles',
                'squiggles',
                'squares',
                'triangles',
                'diamonds'
            ]
        }
    },

    computed: {
        realFill() {
            return getRealColour(this.fill)
        },

        realBgFill() {
            return getRealColour(this.bgFill)
        },

        animatedShape() {
            return this.shapes[this.i]
        },

        realShape() {
            return this.animated ? this.animatedShape : this.shape
        }
    },

    mounted() {
        if (this.animated) {
            this.intervalID = setInterval(this.next, this.interval)
        }
    },

    beforeDestroy() {
        this.intervalID && clearInterval(this.intervalID)
    },

    methods: {
        next() {
            this.i = (this.i + 1) % this.shapes.length
        }
    }
}
</script>
